import React from 'react';
import WebpackerReact from 'webpacker-react';
import Index from '../components/formatos/SuperDuplicator/Index';

const SuperDuplicatorIndex = (props) => <Index {...props} />;

export default SuperDuplicatorIndex;
WebpackerReact.setup({ SuperDuplicatorIndex });
